import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FiExternalLink, FiMapPin, FiPlusCircle, FiClock } from 'react-icons/fi'

const Footer = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-brand">
          <Link to="/" onClick={scrollToTop} className="footer-logo-link">
            <img src="/images/logoadhoc.svg" alt={t('comun.marcaLogo')} className="footer-logo" />
          </Link>
          <p className="footer-tagline">{t('pie.descripcion')}</p>
          <div className="footer-schedule">
            <FiClock />
            <span>{t('pie.horario')}</span>
          </div>
        </div>

        <div className="footer-column">
          <h4>{t('pie.soporte')}</h4>
          <Link to="/nuevo-ticket"><FiPlusCircle /> {t('menu.crearTicket')}</Link>
          <Link to="/" onClick={scrollToTop}>{t('pie.inicio')}</Link>
        </div>

        <div className="footer-column">
          <h4>Agencia Adhoc</h4>
          <a href="https://www.agenciaadhoc.com" target="_blank" rel="noopener noreferrer">
            <FiExternalLink /> www.agenciaadhoc.com
          </a>
          <a href="https://agenciaadhoc.com/contacto" target="_blank" rel="noopener noreferrer">
            <FiMapPin /> {t('pie.contacto')}
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('pie.derechos', { año: year })}</p>
      </div>
    </footer>
  )
}

export default Footer
